import React from "react";

const BridalMakeUpInLavelleEnchance = () => {
  return (
    <div className="hairSalonInLavelleService">
      <h3>Enhance Your Bridal Experience with Pre-Bridal Services</h3>
      <p>
        At SCENT Hair & Beauty Salon, we believe that bridal makeup in Lavelle
        Road should be more than just makeup—it should be an experience. That’s
        why we offer a range of pre-bridal services to ensure you look and feel
        your best. These services include:
      </p>
      <li>
        <h6>Facials and Skincare:</h6>
        <p>
          Prepare your skin for your special day with our advanced facials and
          skincare treatments. Our{" "}
          <a href="https://scentlifestyle.com/service">
            bridal makeup in Lavelle Road
          </a>{" "}
          packages include facials tailored to your skin type, ensuring a
          radiant and healthy complexion.
        </p>
      </li>
      <li>
        <h6>Hair Treatments:</h6>
        <p>
          Get your hair wedding-ready with our hair treatments, including hair
          spas, conditioning treatments, and color services. Our experts will
          ensure your hair looks luscious, shiny, and perfect for styling on
          your wedding day.
        </p>
      </li>
      <li>
        <h6>Nail Care: </h6>
        <p>
          Complete your bridal look with our manicure and pedicure services. Our
          bridal makeup in Lavelle Road packages include nail care services to
          ensure your hands and feet are photo-ready.
        </p>
      </li>
    </div>
  );
};

export default BridalMakeUpInLavelleEnchance;
